import React, { useEffect, useState } from 'react';
import { useForm, Controller } from "react-hook-form";
import { Container, Typography, InputLabel, Paper, Divider, Button, Grid } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from '@material-ui/icons/HighlightOff';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { EntryActions, NotificationActions } from '../../../store';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    logoContainer: {
        top: '500px',
        width: '300px',
        height: '200px',
        margin: 'auto',
        textAlign: 'center',
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        marginLeft: '25%',
        marginRight: '25%',
        padding: '15px',
        width: '50%',
         "& h6": {
            fontSize: '12px'
        }
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})


const merchantsSelector = (state) => state.Merchants;
const IdentitySelector = (state) => state.Identity;

const MerchantApplication = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const entryActions = bindActionCreators(EntryActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(merchantsSelector);
 //   const { token } = useSelector(IdentitySelector);

 //   const { control, errors, handleSubmit, watch ,register } = useForm();
    const { classes, data } = props;

   /***
    * 
    * このウインドウを閉じる。 
    * 
    */
    const onClose = () => {

        if (navigator.userAgent.indexOf("Firefox") != -1 || navigator.userAgent.indexOf("Chrome") != -1) {
            //For Firefox and Chrome it opens a blank page
            window.open(window.location, '_self').close();
            window.location.href = "about:blank";
            window.close();
        } else {
            //Working fine for Microsoft Edge 
            window.opener = null;
            window.open("", "_self");
            window.close();
            window.open(window.location, '_self').close();
        }  
    }
    
    return (
        <Container className={classes.root}>
            <Paper className={classes.paper}>
                <div className={classes.logoContainer}>
                    <img src='../images/Logo.png' alt="OKICA" />
                </div>
                <div className={classes.form}>
                    <Typography component="h1" variant="inherit">{<FormattedMessage id="Merchant.ApplicationAcceptance" />}</Typography>
                </div>
                <div className={classes.form}>
                    <Typography component="h1"><FormattedMessage id={"Merchant.ThankYouText"} /></Typography>
                    <Typography component="h1"><FormattedMessage id={"Merchant.WaitText"} /></Typography>
                    <Typography component="h1"><FormattedMessage id={"Merchant.ResultText"} /></Typography>
                </div>
                <div className={classes.form}>
                    <Typography component="h1"><FormattedMessage id={"Merchant.MailText"} />{editing.mail_adress}</Typography>
                </div>
                <div className={classes.form}>
                    <Typography component="h6">※<FormattedMessage id={"Merchant.MailFilterText"} /></Typography>
                </div>
                <div className={classes.form}>
                    <Button fullWidth variant="contained" size="medium" color="primary"
                        onClick={onClose}>
                        <FormattedMessage id="Button.ClosePage" />
                    </Button>
                </div>
            </Paper>
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(MerchantApplication);
